import React, { useEffect, useRef, useState } from 'react'
import './RamlSection.css'
import { Container, Row, Col } from 'react-bootstrap'


export default function RamlSection({ classs, stat3, num,flaggg,chF2,chF3,chG2,chH2,chJ2 }) {
    const [arrayPoint, setArryPoint] = useState([])
    const [pointCount, setPointCount] = useState(0)
    const [pointCount2, setPointCount2] = useState(0)
    const [offsetX, setOffsetX] = useState()
    const [offsetY, setOffsetY] = useState()
    const [offsetXX, setOffsetXX] = useState()
    const [offsetYY, setOffsetYY] = useState()
    const [number, setNumber] = useState()
    const [getLockal, setGetLockal] = useState()
    const [getLockal2, setGetLockal2] = useState()
    const [getLockal3, setGetLockal3] = useState()
    const [getLockal4, setGetLockal4] = useState()
    const [stating, setStating] = useState(1)
    const [even, setEven] = useState(true)
    const [odd, setOdd] = useState(0)
    const[ispoining,setIsPointing]=useState(false)
    const[add,setAdd]=useState(ispoining)
    const[ch,setCh]=useState()
    const[ok,setOk]=useState(false)
    const[ok2,setOk2]=useState(false)
    const[ok3,setOk3]=useState(false)
    const[ok4,setOk4]=useState(false)


const ggg=()=>{
   
        setOk(true)
    chF2(ok) 
}

const ggg2=()=>{
   
    setOk2(true)
    chG2(ok2) 
}

const ggg3=()=>{
   
    setOk3(true)
chH2(ok3) 
}
const ggg4=()=>{
   
    setOk4(true)
chJ2(ok4) 
}

//   مشخص کردن مختصات هر نقطه کلیک /مشخص کردن صفر یا خط بودن هر قسمت از چهار قسمت کیلک
    const clickPoint = (e) => {                                                                                   
        if (number < 16) {
            setOffsetX(e.clientX)
            setOffsetY(e.clientY)
            setOffsetXX(e.target.offsetLeft)                                          
            setOffsetYY(e.target.offsetTop)
            setPointCount(prev => prev + 1)
            setEven(prev => !prev)
         
        }
if(num==1){
      even ? setOdd(1) : setOdd(0)
        localStorage.setItem(`raml${stat3}`, odd)
        ggg() 
}
if(num==2){
    even ? setOdd(1) : setOdd(0)
    localStorage.setItem(`raml2${stat3}`, odd)
    ggg2() 
}
if(num==3){
    even ? setOdd(1) : setOdd(0)
    localStorage.setItem(`raml3${stat3}`, odd)
    ggg3()
}
if(num==4){
    even ? setOdd(1) : setOdd(0)
    localStorage.setItem(`raml4${stat3}`, odd)
    ggg4() 
}

    }


    ///////////////////////////استیت مربوط به تغییر صفحه رمل
    useEffect(() => {
        setStating(stat3)
        let a = arrayPoint.length

    }, [pointCount])
/////////////////////////////////استیت نقطه کلیک
    useEffect(() => {
        if (offsetX && offsetY && offsetXX && offsetYY) {
            let obj = { offsetX: offsetX, offsetY: offsetY, offsetXX: offsetXX, offsetYY: offsetYY, }
            setArryPoint(prev => [...prev, obj])
        }
    }, [pointCount])
    ///////////////////////////////////استیت تعداد دقیق کلیکها بعد از حذف یا اضافه کردن
    useEffect(() => {
        let u = arrayPoint.length - pointCount2
        setNumber(u)
        setIsPointing(prev=>!prev)
  

    }, [arrayPoint, pointCount2, number])

    //////////////////////
    useEffect(() => {
        if (stat3==4) {
            let getData1 = localStorage.getItem('raml1')
            let getData2 = localStorage.getItem('raml2')
            let getData3 = localStorage.getItem('raml3')
            let getData4 = localStorage.getItem('raml4')
            let getData5 = localStorage.getItem('raml21')
            let getData6 = localStorage.getItem('raml22')
            let getData7 = localStorage.getItem('raml23')
            let getData8 = localStorage.getItem('raml24')
            let getData9 = localStorage.getItem('raml31')
            let getData10 = localStorage.getItem('raml32')
            let getData11= localStorage.getItem('raml33')
            let getData12= localStorage.getItem('raml34')
            let getData13= localStorage.getItem('raml41')
            let getData14= localStorage.getItem('raml42')
            let getData15= localStorage.getItem('raml43')
            let getData16= localStorage.getItem('raml44')
            let obj={r1:getData1,r2:getData2,r3:getData3,r4:getData4}
            let obj2={r1:getData5,r2:getData6,r3:getData7,r4:getData8}
            let obj3={r1:getData9,r2:getData10,r3:getData11,r4:getData12}
            let obj4={r1:getData13,r2:getData14,r3:getData15,r4:getData16}
            setGetLockal(obj)
            setGetLockal2(obj2)
            setGetLockal3(obj3)
            setGetLockal4(obj4)
            let mainObj={
                raml1:`${obj.r1}${obj2.r1}${obj3.r1}${obj4.r1}`,
                raml2:`${obj.r2}${obj2.r2}${obj3.r2}${obj4.r2}`,
                raml3:`${obj.r3}${obj2.r3}${obj3.r3}${obj4.r3}`,
                raml4:`${obj.r4}${obj2.r4}${obj3.r4}${obj4.r4}`,
            }
            localStorage.setItem('mainObject',JSON.stringify(mainObj))

        }
    }, [stating,odd])

    return (
<Container>
    <Row>
        <Col>
        <div className={classs}>
            <div className='ramlsection-divb' onClick={clickPoint}>
                {arrayPoint.map((items, index) =>
                    <div key={index} className='ramlsection-point' style={{ left: `${items.offsetX - items.offsetXX - 1}px`, top: `${items.offsetY - items.offsetYY - 1}px` }}
                    ></div>
                )}
            </div>

        </div>
        </Col>
        </Row>
        </Container>
    )
}
